module.exports = __webpack_public_path__ + "87f1fd22043c47ea87b74e1ab2dca3cd.jpg";